const position = { position: "fixed", bottom: 16, right: 16 };

const scrollTopStyles = {
    position: position,
}

export default scrollTopStyles;